export default "__VITE_ASSET__BE_hjYVB__"